import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
// import $ from 'jquery';
// import Popper from 'popper.js';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from "react-dnd-html5-backend";

// Benign browser warning (often from tables/charts/layout). Suppress so CRA overlay doesn't treat it as a crash.
window.addEventListener("error", (event) => {
  if (
    event.message?.includes("ResizeObserver loop") ||
    event.message?.includes("ResizeObserver loop completed with undelivered notifications")
  ) {
    event.stopImmediatePropagation();
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
   
    <DndProvider backend={HTML5Backend}>
      <App />
    </DndProvider>
  
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
